<template>
  <section
    :class="{
      'platform-viewer': true,
      'platform-viewer--comparisonsQueued': chosenPlatforms.length
    }"
  >
    <header
      :class="[
        'platform-viewer__head',
        'platform-viewer__head--' + currentPlatform.status
      ]"
    >
      <p class="platform-viewer__status">
        {{ platformStatus(currentPlatform.status) }}
      </p>
      <h2 class="platform-viewer__name">
        {{ currentPlatform.displayName }}
      </h2>
      <div v-if="currentPlatform" class="platform-viewer__info">
        <unum-button
          v-if="currentPlatform.status !== 'product_hosted' &&
            this.currentRouteName !== 'FinalSelection'"
          small outline color="leaf4"
          :hovered="isCurrentInCompare"
          @click.native="tryTogglePlatform(currentPlatform)"
        >
          {{isCurrentInCompare ? 'Added To Compare' : 'Compare This'}}
        </unum-button>

        <unum-button
          id="platform-viewer-next-steps-button"
          v-if="this.currentRouteName !== 'FinalSelection' &&
            this.currentPlatform.status !== 'product_hosted'"
          small outline color="blue"
          @click.native.prevent="viewFinal(currentPlatform)"
        >
          Next Steps
        </unum-button>
      </div>
    </header>

    <section
      v-if="currentPlatform.status !== 'product_hosted'"
      :class="[
        'feature-sections',
        { 'feature-sections--final-selection': this.$route.name === 'FinalSelection' }
      ]"
    >
      <section
        v-for="(section) in featureSections"
        :key="section['.key']"
        :class="[
          'feature-section',
          'feature-section--' + section['.key'],
          {
            'feature-section--collapsed': settings.featureCollapse[section['.key']],
            'print-hide': section.displayName === 'Pricing' || section.displayName === 'Sales Contact' || section.displayName === 'Propr Path'
          }
        ]"
      >
        <div class="feature-section__head">
          <h3 class="feature-section__title" @click="toggleFeatureEvent(section['.key'], section.displayName, settings.featureCollapse[section['.key']])">
            {{ section.displayName }}
            <span
              :class="[
                'button',
                'button--blue',
                'button--small',
                'button--outline',
                {'button--hover': settings.featureCollapse[section['.key']]}
              ]"
            >
              {{ settings.featureCollapse[section['.key']] ? 'Show' : 'Hide' }}
            </span>
          </h3>
        </div>
        <div class="feature-section__body">
          <div class="table-wrapper">
            <table
              :class="[
                'features-table',
                'features-table--' + section['.key']
              ]"
            >
              <tr v-for="(feature) in sortFeatures(section.features)" :key="feature['.key']">
                <td class="features-table__cell">
                  {{ feature.displayName }}
                </td>
                <td
                  class="features-table__cell-value"
                  v-if="currentPlatform && currentPlatform.features"
                >
                  <template v-if="feature && feature.notesOnly">
                    <div class="features-table__cell-value--notes-only">
                      <template v-if="currentPlatform.features[feature['.key']]">
                        <span
                          class="feature-note"
                          @click.prevent="handleClick($event)"
                          v-html="currentPlatform.features[feature['.key']].notes ?
                            currentPlatform.features[feature['.key']].notes.trim() : ''"
                        >
                        </span>
                      </template>
                    </div>
                  </template>
                  <template v-else>
                    <div class="features-table__cell-value--flex">
                      <template v-if="currentPlatform.features[feature['.key']]">
                        <unum-icon
                          icon="check"
                          v-if="currentPlatform.features[feature['.key']].available === true"
                        />
                        <unum-icon
                          icon="x-gray"
                          v-if="currentPlatform.features[feature['.key']].available === null || currentPlatform.features[feature['.key']].available === false"
                        />
                        <span
                          class="availability-unknown"
                          v-if="currentPlatform.features[feature['.key']].available === 'unknown'"
                        >
                          Unknown
                        </span>
                        <unum-icon
                          icon="info"
                          v-if="currentPlatform.features[feature['.key']].notes"
                          v-tooltip="currentPlatform.features[feature['.key']].notes.trim() || ''"
                        />
                        <p
                          v-if="currentPlatform.features[feature['.key']].notes"
                          class="print-tooltip"
                        >Note: {{ currentPlatform.features[feature['.key']].notes.trim() || '' }}</p>
                      </template>
                      <template v-else>
                        <unum-icon icon="x-gray" />
                      </template>
                    </div>
                  </template>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </section>

      <section
        v-if="currentPlatform.platformNotes"
        class="feature-section__special-programs"
      >
        <h3>Special Programs</h3>
        {{ currentPlatform.platformNotes }}
      </section>
    </section>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import { db } from '@/appConfig/appConfig'
import UnumButton from '@/components/ui/Button'
import UnumIcon from '@/components/ui/Icon'
import sessionEvent from '@/util/sessionEvent'

export default {
  components: {
    UnumButton,
    UnumIcon
  },
  data () {
    return {
      featureSections: []
    }
  },
  firebase: {
    featureSections: db.ref('blueprints/sections').orderByChild('weight')
  },
  mounted () {
    console.log(this.$route)
  },
  methods: {
    ...mapActions('platforms', [
      'addPlatform',
      'removePlatform',
      'togglePlatform',
      'platformSelection',
      'setCurrentPlatform'
    ]),
    ...mapActions('shared', [
      'toggleFeature',
      'toggleCompareDrawer'
    ]),
    viewFinal (platform) {
      // console.log(platform)
      this.platformSelection(platform)
        .then(res => {
          // if (platform === null || platform.status === 'product_hosted') {
          //   console.log('right here')
          // }
          const sessionKey = this.$storage.get('session_key')
          sessionEvent(sessionKey, 'clicked_lookup_final_selection_button',
            {
              platform: platform.displayName,
              platformKey: platform['.key']
            }, { fromPath: 'Lookup' })
          this.$router.push({ name: 'FinalSelection' })
        })
        .catch(err => {
          console.error(err)
        })
    },
    tryTogglePlatform (platform) {
      this.togglePlatform(platform)
        .then(res => {
          // commented out, client revision
          // if (res.status === 'add') {
          //   this.$notify({
          //     group: 'site_notifications',
          //     type: 'success',
          //     title: 'Comparison Status: ' + res.inCart + '/3',
          //     text: 'Added <strong>' + res.displayName + '</strong>'
          //   })
          // } else if (res.status === 'remove') {
          //   this.$notify({
          //     type: 'error',
          //     group: 'site_notifications',
          //     title: 'Comparison Status: ' + res.inCart + '/3',
          //     text: 'Removed <strong>' + res.displayName + '</strong>'
          //   })
          // }
          const sessionKey = this.$storage.get('session_key')
          sessionEvent(sessionKey, 'toggle_lookup_compare_this_button', {
            platform: platform.displayName,
            state: res.status
          })
          console.log(res)
          if (res.inCart === 3) {
            this.toggleCompareDrawer()
          }
        })
        .catch(err => {
          // commented out, client revision
          // this.$notify({
          //   type: 'error',
          //   group: 'site_notifications',
          //   title: 'Comparison Full',
          //   text: '<strong>' + err.displayName + '</strong> cannot be added. Please remove a platform from the Comparison Cart to add.'
          // })
          console.log(err)
          this.toggleCompareDrawer()
        })
    },
    featuresByWeight (featureSection) {
      let sorted = Object.values(featureSection).sort(function (a, b) {
        return a.weight - b.weight
      })

      return sorted
    },
    getPlatform (platformId) {
      const thePlatform = this.platforms.find((platform) => {
        return platform['.key'] === platformId
      })

      return thePlatform
    },
    sortFeatures (featuresObject) {
      const result = Object.entries(featuresObject)
        .map((feature) => {
          return {
            '.key': feature[0],
            ...feature[1]
            // displayName: feature[1].displayName,
            // weight: feature[1].weight
          }
        })
      return this.featuresByWeight(result)
    },
    platformStatus (platformStatus) {
      switch (platformStatus) {
        case 'fully_integrated':
          return 'Fully Integrated'
        case 'future_integration':
          return 'Future Integration'
        case 'product_hosted':
          return 'Product Hosted'
        default:
          return 'Not Integrated'
      }
    },
    toggleFeatureEvent (sectionKey, sectionDisplayName, sectionToggleState) {
      const sessionKey = this.$storage.get('session_key')
      let currentRoute = ''
      if (this.$store.state.route.path.indexOf('lookup') > -1) {
        currentRoute = 'lookup_'
      }
      if (this.$store.state.route.path.indexOf('final') > -1) {
        currentRoute = 'final_selection_'
      }
      sessionEvent(sessionKey, 'toggle_' + currentRoute + 'platform_section', {
        section: sectionDisplayName,
        toggle_state: sectionToggleState ? 'open' : 'closed'
      })
      this.toggleFeature(sectionKey)
    },
    handleClick (e) {
      if (Element.prototype.msMatchesSelector) {
        if (e.target.msMatchesSelector('a')) {
          window.open(e.target.getAttribute('href'))
        }
      } else {
        if (e.target.matches('a')) {
          window.open(e.target.getAttribute('href'))
        }
      }
    }
  },
  computed: {
    ...mapState('platforms', [
      'chosenPlatforms',
      'currentPlatform',
      'selectedPlatform'
    ]),
    ...mapState('shared', [
      'settings'
    ]),
    ...mapState('route', {
      currentRouteName: 'name'
    }),
    isCurrentInCompare () {
      if (this.currentPlatform) {
        const found = this.chosenPlatforms.find(platform => {
          return platform.displayName === this.currentPlatform.displayName
        })
        // console.log(found)
        if (found) return true
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.platform-viewer {
  &__head {
    padding: 1.5rem;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: #fff;
    border-bottom: .063rem solid $lightBlue;
    z-index: 1;

    &--fully_integrated {
      background: $fullyIntegrated-bgColor;
      .platform-viewer__status {
        color: $fullyIntegrated-textColor;
        &:before {
          background-image: url('~@/assets/images/ui/icon-fully_integrated.svg');
        }
      }
    }

    &--future_integration {
      background: $futureIntegration-bgColor;
      .platform-viewer__status {
        color: $futureIntegration-textColor;
        &:before {
          background-image: url('~@/assets/images/ui/icon-future_integration.svg');
        }
      }
    }

    &--product_hosted {
      background: $productHosted-bgColor;
      .platform-viewer__status {
        color: $productHosted-textColor;
        &:before {
          background-image: url('~@/assets/images/ui/icon-product_hosted.svg');
        }
      }
    }
  }

  &__info {
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  &__status {
    margin: 0 auto .5rem;
    font-size: .75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .063rem;
    padding-left: 1.75rem;

    &:before {
      content: '';
      left: 1.5rem;
      top: 1.25rem;
      width: 1rem;
      height: 1rem;
      position: absolute;
      background-size: contain;
    }
  }

  &__name {
    margin: 0;
    color: $blue
  }

}

.iphone-safari {
  .feature-sections,
  .static-info {
    height: calc(100vh - 228px);
    @include bp($small) {
      height: calc(100vh - 152px);
    }
  }
}

.feature-sections,
.static-info {
  padding-top: 11rem;
  // margin-bottom: 1.25rem;
  position: relative;
  overflow: auto;
  height: calc(100vh - 152px);

  @include bp($small) {
    padding-top: 8.75rem;
  }

  &--final-selection {
    padding-top: 8.75rem;

    @include bp($medium) {
      padding-top: 7.25rem;
      height: calc(100vh - 9.75rem);
    }
    @media print {
      height: auto !important;
    }
  }
}

.static-info {
  article {
    height: 100%;
    padding: 2.5rem;
    background: #fff;
    line-height: 1.4;
  }
}

.feature-section {
  width: 280px;
  background: #fff;
  @include bp($small) {
    width: auto;
  }

  &--collapsed {
    .feature-section__body {
      transition: max-height .25s ease;
      max-height: 0;
    }
  }

  & + .feature-section {
    border-top: .063rem solid #D8E5EE;
  }

  &__body {
    transition: all .5s ease;
    max-height: 420rem;
    overflow: hidden;
    @media print {
      max-height: none !important;
    }
  }

  &__title {
    margin: 0;
    background: $lightBlue;
    padding: 1rem 1.5rem;
    color: $blue;
    cursor: pointer;

    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    @media print {
      display: block;
    }

    .button {
      display: none;
      flex: 0 0 auto;
      @include bp($small) {
        display: block;
      }
      @media print {
        display: none;
      }
    }
  }

  &--pricing,
  &--propr_path,
  &--sales_contact {
    .features-table {
      td {
        &.features-table__cell {
          width: 50%;
        }

        &.features-table__cell-value {
          width: 50%;
          text-align: center;
          word-wrap: break-word;
          overflow-wrap: break-word; // replaces `word-wrap`
          word-break: break-word;
        }

        div.features-table__cell-value--flex {
          max-width: none;
          justify-content: center;
        }
      }
    }
  }

  &--sales_contact {
    .features-table {
      td {
        &.features-table__cell-value {
          word-break: break-all;
          // @include bp($large) {
          //   word-break: none;
          // }
        }
      }
    }
  }

  &__special-programs {
    background: $lightGrey;
    padding: 1.5rem;

    h3 {
      margin-top: 0;
    }
  }
}

.features-table {
  width: 100%;
  border-collapse: collapse;

  tr {
    break-inside: avoid;
  }

  td {
    padding: .5rem 1rem;
    border-bottom: .063rem solid $lightBlue;
    font-weight: 600;
    color: $superDarkBlue;
    font-size: .875rem;
    @include bp($small) {
      padding: .5rem 2.25rem;
    }

    &.features-table__cell {
      width: 75%;
    }

    &.features-table__cell-value {
      width: 25%;
      text-align: center;
      padding: .25rem 1rem;
      @media print {
        max-width: none !important;
        width: 300px;
      }

      &--flex,
      &--notes-only {
        display: flex;
        align-items: center;
        margin: 0 auto;
      }

      &--flex {
        max-width: 6rem;

        .icon--check {
          margin-right: auto;
          justify-self: flex-start;
        }
        .icon--info,
        .button {
          margin-left: auto;
          justify-content: flex-end;
        }
      }

      &--notes-only {
        .feature-note {
          flex: 0 0 100%;
        }
      }
    }

    .features-table__cell-value--flex {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &:first-child {
      border-right: .063rem solid #D8E5EE;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PlatformViewer.vue